<template>
  <div class="p-4">
    <button @click="$modal.show('level')" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded mb-6">
      New Level
    </button>
    <el-table
      :data="levels"
      :empty-text="'No Level available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name">
      </el-table-column>
      <el-table-column
        prop="min_amount"
        label="Minimum Amount">
        <template slot-scope="scope">
          <span>{{numberFormat(scope.row.min_amount)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="min_point"
        label="Minimum Point">
      </el-table-column>
      <el-table-column
        prop="percent"
        label="Percentage">
      </el-table-column>
      <el-table-column
        align="center"
        label="Operations">
        <template slot-scope="scope">
          <el-button type="text" size="small">
            <router-link :to="`/ecommerce/loyalty/levels/${scope.row.id}/customers`">
              <i title="Loyalty Customers" class="text-sm fa fa-users mr-1"></i>
            </router-link>
          </el-button>
          <el-button type="text" size="small">
            <router-link :to="`/ecommerce/loyalty/levels/${scope.row.id}/items`">
              <i title="Loyalty Items" class="text-sm fa fa-shopping-cart mr-1"></i>
            </router-link>
          </el-button>
          <el-button @click="editLevel(scope.row)" type="text" size="small">
            <i title="Update Level" class="text-sm el-icon-edit mr-1"></i>
          </el-button>
          <el-button @click="deleteLevel(scope.row.id)" type="text" size="small">
            <i title="Delete Level" class="text-sm text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <LevelForm />
  </div>
</template>

<script>
import LevelForm from './_includes/LevelForm.vue';

export default {
  name: 'Levels',
  components: {
    LevelForm,
  },

  computed: {
    levels() {
      return this.$store.state.LoyaltyModule.levels;
    },
  },
  methods: {
    editLevel(level) {
      this.$modal.show('level', {
        levelId: level.id,
        level,
      });
    },
    deleteLevel(loyaltyLevelId) {
      this.$confirm('This will permanently delete this loyalty level. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('LoyaltyModule/deleteLoyaltyLevel', { loyaltyId: loyaltyLevelId});
          this.$notify.success({
            title: 'Success',
            message: 'Loyalty Level removed',
          });
        } catch (e) {
          console.log(e)
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  }
};
</script>

<style scoped>

</style>
